import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { showError } from '../constants/toasts';
import { ROLE } from '../utils/enums';

import useAuth from './useAuth';
// import { Permission } from "../services/accessRole";

export interface Permissions {
  label: string;
  isAdd: boolean;
  isView: boolean;
  isDelete: boolean;
  isEdit: boolean;
}

type SidebarLabels =
  | 'Dashboard'
  | 'Registrations'
  | 'Listing'
  | 'Vechile Types'
  | 'Vehile Specifications'
  | 'Blogs'
  | 'Inspection Requests'
  | 'Manage Packages'
  | 'Manage Promo Codes'
  | 'Promotional Campaigns'
  | 'Ratings & Reviews'
  | 'Manage Notifications'
  | 'Manage CMS'
  | 'Manage Payment'
  | 'Analytics';

type PagePermission = 'isView' | 'isAdd';

const usePermission = ({
  label,
  page_permission,
}: {
  label: SidebarLabels;
  page_permission: PagePermission;
}) => {
  const userData = useAuth();
  const navigate = useNavigate();
  const [permission, setPermission] = useState<Permissions | null>();

  const checkPermission = () => {
    const permissions = userData?.accessRoleId?.permission as Permissions[];
    const matchedPermission = permissions.find((perm: Permissions) => perm.label === label);

    if (matchedPermission) {
      setPermission(matchedPermission);
    } else {
      navigate('/permission-denied', { replace: true });
    }
  };

  useEffect(() => {
    if (userData && userData?.role === ROLE.SUBADMIN) {
      checkPermission();
    } else {
      setPermission({
        label: 'admin',
        isAdd: true,
        isView: true,
        isDelete: true,
        isEdit: true,
      });
    }
  }, [userData]);

  useEffect(() => {
    // console.log(permission)
    if (permission && !permission?.[page_permission]) {
      showError('Access denied');
      navigate('/permission-denied', { replace: true });
    }
  }, [permission]);

  return {
    isAdd: !!permission?.isAdd,
    isDelete: !!permission?.isDelete,
    isEdit: !!permission?.isEdit,
    // permission,
  };
};

export default usePermission;
